/**
 * Деньги с точностью до копеек (избегаем 4999.98 из-за float в input/JSON).
 */
export function roundMoney2(v) {
  if (v === '' || v == null) return 0;
  const s = String(v).trim().replace(',', '.');
  const n = parseFloat(s);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100 + Number.EPSILON) / 100;
}
